export const MODEL_DISPLAY_NAMES = {
  zscore: "Normality Threshold Scanner",
  benford: "Benford’s Law (Digital Pattern Integrity Test)",
  rsf: "Relative Size Factor (RSF)",
  lof: "Neighbourhood Outlier Detector",
  pdf: "Value Density Indicator",
  montecarlo: "Risk Outcome Forecast Model",
  ensemble: "Ensemble Models (Multi-Model Integrity Check)",
};

export const MODEL_COLORS = {
  benford: "#60a5fa", // blue
  pdf: "#34d399", // green
  lof: "#8b5cf6", // purple
  rsf: "#f43f5e", // red
  zscore: "#06b6d4", // cyan
  montecarlo: "#f97316", // orange
  ensemble: "#facc15", // yellow
  default: "#94a3b8",
};

const includesAny = (value, patterns = []) =>
  patterns.some((pattern) => value.includes(pattern));

export const normalizeModelKey = (value) => {
  if (value === undefined || value === null) return "";
  const normalized = String(value).toLowerCase();

  if (includesAny(normalized, ["zscore", "z-score", "z_score"])) {
    return "zscore";
  }
  if (includesAny(normalized, ["benford"])) {
    return "benford";
  }
  if (includesAny(normalized, ["pdf", "density"])) {
    return "pdf";
  }
  if (includesAny(normalized, ["lof", "local outlier"])) {
    return "lof";
  }
  if (includesAny(normalized, ["rsf", "rcf", "relative size"])) {
    return "rsf";
  }
  if (includesAny(normalized, ["montecarlo", "monte carlo"])) {
    return "montecarlo";
  }
  if (includesAny(normalized, ["ensemble"])) {
    return "ensemble";
  }

  return normalized.replace(/[^a-z]/g, "");
};

export const getModelDisplayName = (value) => {
  const key = normalizeModelKey(value);
  return MODEL_DISPLAY_NAMES[key] || value || "";
};

export const getModelColor = (value) => {
  const key = normalizeModelKey(value);
  return MODEL_COLORS[key] || MODEL_COLORS.default;
};

